import './TourGuide.css';
export default {
    "root": "TourGuide_root__cn9qi",
    "title": "TourGuide_title__cn9qi",
    "titleHasCloseButton": "TourGuide_titleHasCloseButton__cn9qi",
    "content": "TourGuide_content__cn9qi",
    "contentHasCloseButton": "TourGuide_contentHasCloseButton__cn9qi",
    "bottomRow": "TourGuide_bottomRow__cn9qi",
    "stepCount": "TourGuide_stepCount__cn9qi",
    "stepCountDesktop": "TourGuide_stepCountDesktop__cn9qi",
    "stepCountMobile": "TourGuide_stepCountMobile__cn9qi",
    "buttonGroup": "TourGuide_buttonGroup__cn9qi",
    "leftButton": "TourGuide_leftButton__cn9qi",
    "rightButtonStandalone": "TourGuide_rightButtonStandalone__cn9qi",
    "closeButton": "TourGuide_closeButton__cn9qi"
};
